import React, { useContext, useRef, useEffect, useState } from "react";
import styled from "styled-components";
import { TitleText } from "../../ui/Text";
import { CircleIcon } from "../../assets/svg/CircleIcon";
import { EyeIcon } from "../../assets/svg/EyeIcon";
import { FinancialIcon } from "../../assets/svg/FinancialIcon";
import { LearningIcon } from "../../assets/svg/LearningIcon";
import { CustomerIcon } from "../../assets/svg/CustomerIcon";
import { ProcessesIcon } from "../../assets/svg/ProcessesIcon";
import StrategymapCard from "../../components/strategymapCard/StrategymapCard";
import { GetHook } from "../../api/api";
import { STRATEGYMAP_URL, SCORECARD_URL } from "../../api/urls";
import { AuthContext } from "../../context/AuthContext";
import { get } from "../../utils/get";
import { Formik, Field } from "formik";
import { DropDown } from "../../ui/DropDown";
import { parseDropdown } from "../../utils/parseDropdown";
import Axios from "../../utils/axios";
import { colors } from "../../utils/colors";
import find from "lodash/find";
import useAuth from "../../hooks/useAuth";
const StrategyMap = () => {
  const [strategyMap, setStrategyMap] = useState({});
  const [cardData, setCardData] = useState([]);

  const auth = useAuth();

  const { isAdmin, authState } = auth;
  const endPoint = !isAdmin()
    ? `?owner_id=${get(authState, "user.organisation.manager.id")}`
    : "";
  const { data: strategyMaps } = GetHook(`${STRATEGYMAP_URL}${endPoint}`);

  useEffect(() => {
    if (strategyMaps.length) {
      setStrategyMap(strategyMaps[0]);
    }
    return () => {};
  }, [strategyMaps]);

  const options = strategyMaps.map((sm) => {
    return { label: get(sm, "name"), value: get(sm, "id") };
  });

  const fetchObjectives = () => {
    Axios.get(
      `${STRATEGYMAP_URL}/${
        get(strategyMap, "id") || get(strategyMap, "[0]id")
      }/objective`
    ).then((res) => {
      const { returned_resultset } = get(res, "data");
      setCardData(returned_resultset);
    });
  };

  useEffect(() => {
    if (get(strategyMap, "id") || get(strategyMap, "[0]id")) {
      fetchObjectives();
    }
    return () => {};
  }, [strategyMap]);

  const linkedData: any = [];

  cardData.map((item, i) => {
    const obj: any = {
      id: get(item, "primary_objective_id"),
      name: get(item, "primary_objective.name"),
      title: get(item, "primary_objective.name"),
      perspective: get(item, "primary_objective.perspective"),
      color: colors[i],
    };

    const obj1: any = {
      id: get(item, "linked_objective_id"),
      title: get(item, "linked_objective.name"),
      name: get(item, "linked_objective.name"),
      pid: get(item, "primary_objective_id"),
      perspective: get(item, "linked_objective.perspective"),
      color: colors[i + 3],
    };

    linkedData.push(obj, obj1);
  });

  const linkage = cardData.map((item, i) => {
    const obj = {
      id: get(item, "linked_objective_id"),
      pid: get(item, "primary_objective_id"),
      color: linkedData.find((a) =>
        a.id === get(item, "primary_objective_id") ? a.color : ""
      ),
    };

    return obj;
  });

  const data = Array.from(new Set(linkedData.map((a) => a.id))).map((id) => {
    return linkedData.find((a) => a.id === id);
  });

  return (
    <StrategyMapContainer>
      <StrategymapHeader>
        <TitleText>Strategy Map</TitleText>
        <Formik
          enableReinitialize
          initialValues={{ strategy_map: options.length ? options[0] : "" }}
          onSubmit={() => console.log("submitted")}
        >
          {({ setFieldValue }) => {
            return (
              <Field
                name="strategy_map"
                component={DropDown}
                width="90%"
                options={options}
                onChange={(values) => {
                  setFieldValue("strategy_map", values);
                  setStrategyMap(
                    strategyMaps.filter(
                      (map) => map.id === get(values, "value")
                    )
                  );
                }}
                placeholder="select..."
              />
            );
          }}
        </Formik>
      </StrategymapHeader>
      <GoalsContainer>
        <Goal>
          <CircleIcon />
          <TitleText style={{ fontSize: 12 }}>
            {get(strategyMap[0], "vision")}
          </TitleText>
        </Goal>
        <Goal>
          <EyeIcon />
          <TitleText style={{ fontSize: 12 }}>
            {get(strategyMap[0], "mission")}
          </TitleText>
        </Goal>
      </GoalsContainer>
      <MapContainer>
        <CardsConatiner>
          <PerspectiveCard>
            <FinancialIcon />
            <TitleText>Financial</TitleText>
          </PerspectiveCard>
          <StrategymapCard
            cardData={data.filter(
              (item) =>
                item.perspective &&
                item.perspective.name.indexOf("Financial") >= 0
            )}
          />

          <PerspectiveCard>
            <CustomerIcon />
            <TitleText>Customer</TitleText>
          </PerspectiveCard>
          <StrategymapCard
            cardData={data.filter(
              (item) =>
                item.perspective &&
                item.perspective.name.indexOf("Customer") >= 0
            )}
          />
          <PerspectiveCard>
            <ProcessesIcon />
            <TitleText>Processes</TitleText>
          </PerspectiveCard>
          <StrategymapCard
            cardData={data.filter(
              (item) =>
                item.perspective &&
                item.perspective.name.indexOf("Processes") >= 0
            )}
          />
          <PerspectiveCard>
            <LearningIcon fill="#fff" />
            <TitleText>Learning</TitleText>
          </PerspectiveCard>
          <StrategymapCard
            linkData={linkage}
            cardData={data.filter(
              (item) =>
                item.perspective &&
                item.perspective.name.indexOf("Learning") >= 0
            )}
          />
        </CardsConatiner>
      </MapContainer>
    </StrategyMapContainer>
  );
};

export default StrategyMap;

const StrategyMapContainer = styled.div`
  display: grid;
  grid-template-rows: 5em 10em auto;
  background-color: #f5f6fb;
`;

const StrategymapHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 0.5px solid rgba(55, 81, 255, 0.1);
  align-items: center;
  padding: 0 2em 0 2em;
  justify-content: space-between;
`;

const GoalsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 3em;
  padding: 0 2em 0 2em;
`;
const Goal = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1em;
  background-color: #fff;
  border-radius: 0.5em;
  margin: 2em 0;
  ${TitleText} {
    margin-left: 2em;
  }
`;

const MapContainer = styled.div`
  display: grid;
  column-gap: 1em;
  padding: 0 2em 0 2em;
`;

const CardsConatiner = styled.div`
  display: grid;
  grid-template-columns: 10em auto;
  grid-template-rows: 1fr 1fr 1fr 1fr;
  row-gap: 1em;
`;

const PerspectiveCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 1.5em 0.5em;
  border-radius: 0.5em;
  border: 1px solid rgba(55, 81, 255, 0.1);
  transform: rotate(270deg);
  height: 2.5rem;
  width: 120%;
  margin-top: 5em;
  margin-bottom: 1em;
  margin-left: -3.5rem;
  ${TitleText} {
    margin-left: 2em;
  }
`;
